// Settings translations (English catalog).
window.PlummeI18n.register('en', {
  'set.acc.assetAutomaticPostingExplanation': 'Depreciation is posted automatically for each completed month. Plumme catches up on missed months without any action from you.',
  'set.acc.paymentDays': 'Default payment terms (days)',
  'set.acc.paymentDaysHelp': 'The due date follows the invoice date using these terms. You can override the due date on each invoice.',
  'set.acc.paymentDaysInvalid': 'Choose a payment term from 0 to 365 whole days.',
  'set.acc.foreignCurrencyInvoices': 'Sales in foreign currencies',
  'set.acc.foreignCurrencyInvoicesHelp': 'Show document currency and exchange-rate fields in New sale. Leave this off if you only invoice in the accounting currency.',
  'set.acc.advancedVatDeduction': 'Advanced input VAT deduction on purchase lines',
  'set.acc.advancedVatDeductionHelp': 'Show full or partial deduction controls when the document includes VAT. The normal value is 100%, and existing exceptions are always shown.',
  'set.acc.openingAssets': 'Fixed assets in the opening balance',
  'set.acc.openingAssetsHelp': 'Register details for assets already included in the opening balance. Amounts are reconciled to the opening balance while the assets remain in the asset register.',
  'set.acc.openingAssetsAction': 'Register an existing fixed asset',
  'set.acc.assetAutomation': 'Automatic monthly depreciation posting',
  'set.acc.assetAutomationHelp': 'Review the amount and period before confirming. Activation posts outstanding completed months and approves ongoing automation. Pausing does not remove posted vouchers.',
  'set.acc.assetAutomationActive': 'Active for the selected fiscal year.',
  'set.acc.assetAutomationOff': 'Disabled for the selected fiscal year.',
  'set.acc.assetAutomationReview': 'Paused. Review and approve the updated asset basis before further automatic posting.',
  'set.acc.assetAutomationEnableNote': 'Approved automatic monthly posting of accounting depreciation.',
  'set.acc.assetAutomationDisableNote': 'Automatic monthly posting stopped by the user.',
  'set.bank.activeFromHelp': 'Follow-up only expects bank statements from this date onward.',
  'set.bank.noReconciliationHelp': 'Without bank reconciliation you must check yourself that all bank movements are recorded once, that the bank balance matches the accounts, and that personal and business payments aren\'t mixed.',
  'set.bank.newAccount': 'New bank account',
  'set.bank.invoiceDeleteBlocked': 'The invoice account cannot be deleted until another account is chosen',
  'set.bank.deleteOrDisable': 'Delete or deactivate account',
  'set.bank.openingBalanceHelp': 'The bank balance at the end of the last date already reconciled. It anchors bank reconciliation but does not post an accounting opening balance; enter that under Accounting with an offsetting account.',
  'set.bank.openingBalanceDateHelp': 'Plumme starts bank reconciliation the day after this date.',
  'set.bank.setupValidation.date': "Choose a valid date.",
  'set.bank.setupValidation.year': "The date must fall in accounting year {year}. Switch accounting year to set up another year.",
  'set.bank.setupValidation.amount': "Enter the documented bank balance. Enter 0 if the account was empty.",
  'set.bank.setupValidation.counter': "Choose the counter account from the documented opening balance.",
  'set.bank.setupTitle': 'Set up starting balance',
  'set.bank.setupIntro': 'Record the documented bank balance and the balanced accounting entry in one flow. Plumme never guesses the offsetting account.',
  'set.bank.setupYearStart': 'Start at a new fiscal year',
  'set.bank.setupYearStartHelp': 'Use the balance at the end of the previous year as the bank opening balance in the new year.',
  'set.bank.setupMidYear': 'Move to Plumme mid-year',
  'set.bank.setupMidYearHelp': 'Use the balance on the day before Plumme takes over the bookkeeping.',
  'set.bank.setupNewAccount': 'New bank account in ongoing books',
  'set.bank.setupNewAccountHelp': 'A transfer to a new account is an ordinary transaction, not an opening balance.',
  'set.bank.setupUnsupported': 'Combined bank and accounting starting balances are currently supported only for Norwegian NOK accounts. Use the separate accounting and bank flows for this account.',
  'set.bank.setupNewAccountTitle': 'Record the actual transfer',
  'set.bank.setupNewAccountBody': 'Create or import the transaction that moved the money to the account. Once the ledger agrees with the bank, reconciliation can begin without a new opening balance.',
  'set.bank.setupTransitionDate': 'First day in Plumme',
  'set.bank.setupTransitionYearHint': "The first day of the selected fiscal year. ({year})",
  'set.bank.setupTransitionMidYearHint': 'The date Plumme takes over from the previous system.',
  'set.bank.setupEvidenceDate': 'Bank balance as of',
  'set.bank.setupEvidenceDateHint': 'Calculated as the day before Plumme takes over.',
  'set.bank.setupBankBalance': 'Documented bank balance',
  'set.bank.setupBankBalanceHint': 'Use the statement balance on the cut-off date.',
  'set.bank.setupLedgerAccount': 'Bank ledger account',
  'set.bank.setupCounterAccount': 'Offsetting opening-balance account',
  'set.bank.setupCounterHelp': 'Choose where the bank amount came from. The bank balance alone cannot determine this.',
  'set.bank.setupChooseCounter': 'Choose offsetting account',
  'set.bank.setupNoCounter': 'No offsetting account needed for a zero balance',
  'set.bank.setupNoCounterMatches': 'No balance-sheet accounts match the search.',
  'set.bank.setupManagedInBank': 'Linked to the starting balance under Settings - Bank',
  'set.bank.setupMidYearWarning': 'The bank balance is only one part of the transition. Also enter or import the other balance-sheet, profit-and-loss and VAT figures from the previous system under Accounting.',
  'set.bank.setupPreview': 'Saved together',
  'set.bank.setupPreviewText': 'Bank evidence: {amount} at cut-off. Accounting opening balance: {bank} against {counter}.',
  'set.bank.setupNotChosen': 'offsetting account not chosen',
  'set.bank.setupSave': 'Save balance and opening entry',
  'set.bank.setupSaveError': 'Could not save the starting balance.',
  'set.bank.setupPostingNote': 'Bank starting balance – {account}',
  'set.bank.setupButton': 'Set up or correct starting balance',
  'set.bank.setupSummaryTitle': 'Bank balance at start',
  'set.bank.setupSummaryEmpty': 'Starting balance and accounting opening balance have not been set up.',
  'set.bank.setupSummaryValue': '{amount} as of {date}',
  'set.bank.setupSaved': 'Starting balance and opening balance saved',
  'set.bank.setupSaveAccountFirst': 'Save the bank account first. You can then set up the starting balance and opening entry together.',
  'set.bank.iban': 'IBAN',
  'set.bank.bic': 'BIC',
  'set.bank.showIbanBicOnInvoice': 'Show IBAN and BIC on invoices',
  'set.role.owner': 'Owner',
  'set.access.noOrgNumber': 'No org. number',
  'set.access.onboardingUnavailable': 'Onboarding is not loaded.',
  'set.access.members': 'Members',
  'set.access.membersSub': 'Owners and admins can remove active access. Ownership must be transferred before the owner\'s own access can be removed.',
  'set.access.membersOnlyAdmin': 'Only the owner and admin can manage members.',
  'set.access.selfRemoveHelp': 'You can still remove your own access if you\'re not the owner.',
  'set.access.you': 'you',
  'set.access.remove': 'Remove',
  'set.access.membersEmpty': 'Active members are shown to the owner and admin.',
  'set.access.removeSelf': 'Remove my access',
  'set.access.transferTitle': 'Transfer ownership',
  'set.access.transferSub': 'Send a controlled invitation to a new owner. Ownership moves only once the recipient logs in and accepts.',
  'set.access.transferOnlyOwner': 'Only the owner can transfer ownership.',
  'set.access.transferAdminHelp': 'Admins can invite partners, but cannot change the owner.',
  'set.access.newOwnerEmail': 'New owner\'s email',
  'set.access.afterTransferRole': 'Your access after transfer',
  'set.access.roleAdministrator': 'Administrator',
  'set.access.transferReason': 'Reason / audit note',
  'set.access.transferReasonPlaceholder': 'E.g. sold the company or set up for a client',
  'set.access.sendTransfer': 'Send ownership transfer',
  'set.access.ownershipTransfer': 'Ownership transfer',
  'set.access.expired': 'Expired',
  'set.access.viewAccept': 'View and accept',
  'set.access.unknown': 'unknown',
  'set.access.resend': 'Resend',
  'set.tab.accounting': 'Accounting',
  'set.tab.data': 'Data',
  'set.companyEmailHint': 'Fetched from your login.',
  'set.countryLocked': 'Country is selected when the business is created and cannot be changed here. Contact support to correct an error.',
  'set.inboxUpdatedAt': 'Last updated {date}',
  'set.inboxCopied': 'Email copied',
  'set.profileEmailHint': 'Email isn\'t changed here, since Firebase may require a new login.',
  'set.subscriptionPlan': 'Plan: {plan}',
  'set.subscriptionInactive': 'Subscription not activated',
  'set.subscriptionTrialUntil': 'Trial period until {date}',
  'set.subscriptionChooseHelp': 'Choose a plan to start checkout in Stripe.',
  'set.subscriptionDisconnected': 'Not connected',
  'set.subscriptionCurrentPlan': 'Current plan',
  'set.subscriptionChoosePlan': 'Choose {name}',
  'set.subscriptionFeature.bookkeeping': 'Bookkeeping',
  'set.subscriptionFeature.invoiceEmailEhf': 'Invoice by email and EHF',
  'set.subscriptionFeature.publicFiling': 'Submission to the authorities',
  'set.subscriptionFeature.invoiceEmail': 'Invoice by email',
  'set.subscriptionFeature.taxFigures': 'Figures for VAT and tax return',
  'set.subscriptionFeature.taxIntegration': 'Integration with the Norwegian Tax Administration',
  'set.acc.setupTab': 'Setup',
  'set.acc.chartTab': 'Chart of accounts',
  'set.acc.vatPeriodAnnual': 'Annually',
  'set.acc.vatPeriodBimonthly': 'Every other month',
  'set.acc.vatPeriodMonthly': 'Monthly',
  'set.acc.vatPeriodQuarterly': 'Quarterly',
  'set.acc.vatPeriod.monthly': 'Monthly',
  'set.acc.vatPeriod.bimonthly': 'Every other month',
  'set.acc.vatPeriod.quarterly': 'Quarterly',
  'set.acc.vatPeriod.semiannual': 'Twice a year',
  'set.acc.vatPeriod.annual': 'Annually',
  'set.acc.vatPeriodEffectiveYear': 'Effective from year',
  'set.acc.vatPeriodEffectiveYearHelp': 'Enter the year stated in the Tax Administration decision. The change applies from 1 January of that year. A closed year must be reopened and submitted VAT returns must be reopened or reversed first.',
  'set.acc.vatPeriodEffectiveYearInvalid': 'Enter a valid four-digit year.',
  'set.acc.vatPeriodHistory': 'VAT filing-frequency history',
  'set.acc.vatPeriodConfirmTitle': 'Are you sure you want to change the VAT filing frequency?',
  'set.acc.vatPeriodConfirmText': 'The change takes effect on 1 January {year}. Check that the year matches the Tax Administration decision. Earlier years remain unchanged. A closed year must be reopened and submitted VAT returns must be reopened or reversed first.',
  'set.acc.vatPeriodConfirm': 'Confirm change',
  'set.acc.notVatRegisteredNotice': 'When the company isn\'t VAT registered, new invoices are set to 0% VAT. Purchases can still be recorded with VAT on the document, but without a deduction right.',
  'set.acc.midYearText': 'Use this if you move to Plumme mid-year and want reports to continue with figures from a previous system.',
  'set.acc.openingSaved': 'Starting figures saved',
  'set.acc.openingSavedFrom': 'Starting figures saved from {date}.',
  'set.acc.openingBalanceText': 'Use this if you start a new fiscal year and want to enter opening balance figures from the previous year.',
  'set.startup.linkedBalanceTitle': 'Opening balance included',
  'set.startup.linkedBalanceHelp': 'These are the same balance lines shown in the opening-balance wizard. Bank lines are corrected under Settings - Bank.',
  'set.acc.balanceBooked': 'Recorded {date} - {count} {lines}',
  'set.acc.line': 'line',
  'set.acc.lines': 'lines',
  'set.acc.enterAccountNumber': 'Enter account number',
  'set.acc.equivalentHint': 'Controls handling in year-end close and tax return.',
  'set.acc.saveChart': 'Save chart of accounts',
  'set.acc.equivalentShort': 'Equivalent',
  'set.acc.usedInHistory': 'Used in history',
  'set.acc.activate': 'Activate',
  'set.acc.editAccount': 'Edit account',
  'set.acc.deactivateUsed': 'Deactivate used account',
  'set.acc.deleteUnused': 'Delete unused account',
  'set.ib.intro': 'Here you enter opening balance figures from the previous fiscal year. Use this when starting a new year and you want the balance to be correct from day one in Plumme.',
  'set.ib.attachment': 'Attachment',
  'set.ib.uploadDocuments': 'Upload documents',
  'set.ib.uploading': 'Uploading...',
  'set.ib.created': 'Created',
  'set.ib.uploadReceipt': 'Upload new receipt',
  'set.ib.emptyHelp': 'You must add at least one line before you can create an opening balance. Use the "Add new line" button to enter the figures from the previous system.',
  'set.ib.postHelp': 'Confirm that the opening balance is correct and ready to be posted. You can still change it afterwards as long as the period is open.',
  'set.ib.draftFor': 'Draft opening balance for {date}',
  'set.ib.createdAt': 'Created {date}',
  'set.ib.balanceHelp': 'Enter the balance for each account from the closed accounts. The complete opening balance must have equal debit and credit totals.',
  'set.ib.noteOptional': 'Note (optional)',
  'set.ib.difference': 'Difference',
  'set.ib.saveDraft': 'Save draft',
  'set.ib.validationHelp': 'Check that every line has an account and a positive amount on exactly one side, and that total debit equals total credit.',
  'set.ib.excludedRows': '{count} profit-and-loss or unknown accounts are excluded from an ordinary opening balance. Review them in the import source.',
  'set.transitionImport.confirmSigned': 'Confirm column and sign convention before import',
  'set.transitionImport.balanceColumn': 'Balance column',
  'set.transitionImport.signConvention': 'Sign convention',
  'set.transitionImport.positiveDebit': 'Positive is debit, negative is credit',
  'set.transitionImport.positiveCredit': 'Positive is credit, negative is debit',
  'set.transitionImport.signExample': 'Example: With “positive is debit”, −427,473.92 becomes credit 427,473.92.',
  'set.transitionImport.confirmImport': 'Confirm and preview',
  'set.transitionImport.helpImage': 'SAF-T, Excel, CSV or image. Drag in or paste with Ctrl+V.',
  'sd.deleteAllTitle': 'Delete all {label}',
  'sd.deleteAllMessage': 'Delete all {label} ({count})? Historical invoices and receipts are kept, but the register is emptied. This cannot be undone. We recommend exporting first.',
  'sd.label.customers': 'customers',
  'sd.label.suppliers': 'suppliers',
  'sd.label.products': 'products',
  'sd.importing': 'Importing...',
  'sd.documentReferenceMissing': 'The document has no reference to the import package.',
  'sd.documentLinkFailed': 'Could not retrieve the document link.',
  'sd.documentOpenFailed': 'Could not open the imported document.',
  'sd.kind.voucher': 'Voucher',
  'sd.kind.inbox': 'Inbox',
  'sd.kind.bankReconciliation': 'Bank reconciliations',
  'sd.kind.company': 'Company documents',
  'sd.kind.invoice': 'Invoice',
  'sd.kind.quote': 'Quote',
  'sd.kind.creditNote': 'Credit note',
  'sd.kind.orderConfirmation': 'Order confirmation',
  'sd.kind.paymentReminder': 'Payment reminder',
  'sd.kind.otherCount': 'Other {count}',
  'sd.kind.allCount': 'All {count}',
  'sd.reportCsv': 'Report CSV',
  'sd.reportXlsx': 'Report XLSX',
  'sd.openItems.exported': '{count} open items exported',
  'sd.openItems.exportFailed': 'Could not export the report.',
  'sd.openItems.title': 'Review imported open items',
  'sd.openItems.count': 'open items',
  'sd.openItems.remainingTotal': 'total remaining amount',
  'sd.openItems.possibleDeviations': 'possible discrepancies',
  'sd.openItems.search': 'Search by name, invoice no., date or sheet',
  'sd.filter.all': 'All',
  'sd.filter.customers': 'Customers',
  'sd.filter.suppliers': 'Suppliers',
  'sd.openItems.checkDeviation': 'Check discrepancies against subledger balance',
  'sd.openItems.deviation': '{label}: {party} differs by {amount}',
  'sd.unnamed': 'No name',
  'sd.openItems.rowMeta': '#{invoice} · date {date} · due {due}',
  'sd.openItems.empty': 'No open import items match the filter.',
  'sd.documents.title': 'Imported document archive',
  'sd.documents.count': 'documents',
  'sd.documents.types': 'types',
  'sd.documents.packages': 'export packages',
  'sd.documents.search': 'Search by file, year, voucher no. or internal path',
  'sd.documents.sortType': 'Sort: type',
  'sd.documents.sortYear': 'Sort: year',
  'sd.documents.sortName': 'Sort: file name',
  'sd.documents.basis': 'Archive basis',
  'sd.documents.basisHelp': 'The documents are stored as an import index against the original export package. They do not automatically create invoices, purchases, vouchers or inbox items.',
  'sd.documents.fallback': 'Document',
  'sd.documents.unknownPath': 'Unknown path in the export package',
  'sd.documents.fetching': 'Fetching...',
  'sd.documents.open': 'Open',
  'sd.documents.empty': 'No imported documents match the filter.',
  'sd.ledger.title': 'Imported ledger archive',
  'sd.ledger.linesShown': 'history lines in shown archive',
  'sd.ledger.debitShown': 'debit in shown selection',
  'sd.ledger.creditShown': 'credit in shown selection',
  'sd.ledger.search': 'Search by voucher, account, text, date or source',
  'sd.ledger.allYears': 'All years',
  'sd.ledger.historyOnly': 'History only',
  'sd.ledger.historyHelp': 'Lines here are a readable import archive from the previous system. The totals above are debit/credit for the shown archive selection, not turnover. These lines are not included in Plumme reports, VAT, tax, bank reconciliation or the live voucher list.',
  'sd.ledger.noText': 'No text',
  'sd.ledger.linkedCount': '{count} linked voucher(s) in the document archive',
  'sd.ledger.empty': 'No imported ledger lines match the filter.',
  'sd.ledger.linkedTitle': 'Linked vouchers',
  'sd.ledger.archiveDocument': 'Archive document',
  'sd.ledger.archiveDocumentHelp': 'These are document references from the original export package. They do not create live vouchers or inbox items.',
  'sd.ledger.noDocumentDetails': 'No document details saved for this line.',
  'sd.ledger.showing': 'Showing {shown} of {total} matches for this history line.',
  'sd.transition.exported': '{count} years exported',
  'sd.transition.exportFailed': 'Could not export the transition report.',
  'sd.transition.title': 'Reconciliation and transition report',
  'sd.transition.years': 'years',
  'sd.transition.openingLines': 'Opening balance lines',
  'sd.transition.historyLines': 'history lines',
  'sd.transition.warnings': 'control warnings',
  'sd.transition.control': 'Transition control',
  'sd.transition.controlHelp': 'The report compiles imported opening balance, subledger, bank and ledger history per year. The figures are a control basis and are not booked automatically.',
  'sd.transition.latestSubledger': 'Imported subledger balance without its own year is shown on {year} as the most recently imported subledger.',
  'sd.transition.rowSummary': '{opening} opening balance lines · {accounts} historical account balances · {history} history lines · bank opening balance {bank}',
  'sd.transition.warningCount': '{count} warning(s)',
  'sd.transition.discrepancy': 'Discrepancy {amount}',
  'sd.transition.historicalBalance': 'Historical balance',
  'sd.transition.balanceSequence': 'Opening / change / closing',
  'sd.transition.historicalResult': 'Historical result',
  'sd.transition.incomeCost': 'Income {income} · cost {cost}',
  'sd.transition.itemsDeviation': '{count} items · discrepancy {amount}',
  'sd.transition.supplierSubledger': 'Supplier subledger',
  'sd.transition.ledgerArchive': 'Ledger archive',
  'sd.transition.empty': 'No imported transition figures to show yet.',
  'sd.vatTax.exported': '{count} lines exported',
  'sd.vatTax.exportFailed': 'Could not export the VAT/tax history.',
  'sd.vatTax.title': 'VAT and tax from import history',
  'sd.vatTax.periods': 'VAT periods',
  'sd.vatTax.netVat': 'net VAT',
  'sd.vatTax.resultBeforeTax': 'result before tax',
  'sd.vatTax.basis': 'Historical control basis',
  'sd.vatTax.basisHelp': 'VAT is summed from imported 270x/271x accounts per period. SAF-T VAT codes are shown as code basis where the export file contains them. This does not create new VAT returns, vouchers or tax entries.',
  'sd.vatTax.yearSummary': '{count} periods · result before tax {amount}',
  'sd.vatTax.archive': 'Archive',
  'sd.vatTax.period': 'Period {number} · {label}',
  'sd.vatTax.outputInput': 'Output {output} · input {input}',
  'sd.vatTax.empty': 'No imported VAT/tax history to show yet.',
  'sd.vatTax.codes': 'SAF-T VAT codes',
  'sd.vatTax.showing': 'Showing {shown} of {total}',
  'sd.vatTax.code': '{year}-{month} code {code}',
  'sd.vatTax.baseVat': 'Base {base} · VAT {vat} · {rate}%',
  'sd.resetMessage': 'This permanently deletes all accounting and operating data in the selected business: invoices, vouchers, payments, customers, suppliers, products, payroll, bank data, opening balances, import archives, files and all number sequences. This cannot be undone. Create a complete export first if anything must be kept.',
  'sd.resetPreserved': 'The business profile, members, subscription and integration connections are kept. Use “Delete business” if those must also be removed.',
  'sd.resetPhrase': 'CONFIRM',
  'sd.resetTypeLabel': 'Type {phrase} to enable reset',
  'sd.resetTypeHint': 'The button stays disabled until the text matches exactly.',
  'sd.resetConfirm': 'Delete and reset everything',
  'sd.resetComplete': 'All accounting and operating data has been deleted. The business has been reset.',
  'sd.resetFailed': 'Could not complete the reset.',
  'sd.deleteBusinessMessage': 'Schedule deletion of the selected company in 30 days? The company, its data and access will be removed after the grace period. You can cancel the deletion before the deadline.',
  'sd.deleteBusinessConfirm': 'Schedule deletion',
  'sd.customersTitle': 'Import / Export of Customers',
  'sd.suppliersTitle': 'Import / Export of Suppliers',
  'sd.productsTitle': 'Import / Export of Products',
  'sd.invoicesTitle': 'Import / Export of Invoices',
  'sd.vouchersTitle': 'Import / Export of Vouchers',
  'sd.supportedFormats': 'Supported import formats: .xlsx and .csv.',
  'sd.productsHelp': 'Import and export products with template columns. Supported import formats: .xlsx and .csv.',
  'sd.invoicesHelp': 'Export invoices as CSV, or import new invoices with a template.',
  'sd.vouchersHelp': 'Export voucher overview or ledger lines. Import is safely analyzed as a complete export package.',
  'sd.importInvoices': 'Import invoices',
  'sd.buildingExport': 'Building export package...',
  'sd.exportAll': 'Export all (.zip)',
  'sd.technicalJson': 'Technical JSON',
  'sd.analyzing': 'Analyzing...',
  'sd.importOtherSystem': 'Import from another system',
  'sd.reviewOpenItems': 'Review open items',
  'sd.documentArchive': 'Document archive',
  'sd.ledgerArchive': 'Ledger archive',
  'sd.transitionReport': 'Transition report',
  'sd.vatTaxHistory': 'VAT/tax history',
  'sd.latestAnalysis': 'Latest analysis: {files} files, {saft} SAF-T, {excel} Excel, {vouchers} voucher files. Status: {status}.',
  'sd.analyzed': 'analyzed',
  'sd.reanalyze': 'Re-analyze same file',
  'sd.reread': 'Re-read import file',
  'sd.rereadHelp': 'The latest import file is saved, but the analysis is not finished or has failed.',
  'sd.importProposal': 'Suggestion: {accounts} trial balance accounts, {customers} customers, {suppliers} suppliers, {products} products, {customerInvoices} open customer invoices, {supplierInvoices} open supplier invoices, {balances} opening balances, {documents}, {ledger}.',
  'sd.countShown': '{shown}+ {label} (showing {shown} of {total})',
  'sd.label.archiveDocuments': 'archive documents',
  'sd.label.historyLines': 'history lines',
  'sd.saftTitle': 'Export SAF-T',
  'sd.saftHelp': 'Export SAF-T Financial XML (beta), or import chart of accounts, parties and opening balance from SAF-T XML.',
  'sd.importSaft': 'Import SAF-T (MVP)',
});
